import React, { useEffect } from 'react'
import { Redirect, Route, Switch, RouteProps } from 'react-router-dom'
import { useAppSelector } from '../hooks/useRedux'
import paths from './paths'

import Login from '../pages/Login'
import Home from '../pages/Home'
import New from '../pages/New'
import Plants from '../pages/Plants'
import Scenarios from '../pages/Scenarios'
import Results from '../pages/Results'
import StorageSystems from '../pages/StorageSystems'
import ResultDetail from '../pages/Results/ResultDetail'
import ResultComparison from '../pages/Results/ResultComparison'
// import Users from '../pages/Users'

const ProtectedRoute: React.FC<RouteProps> = ({ ...props }) => {
  const { isLoggedIn } = useAppSelector(({ user }) => user)

  return isLoggedIn ? <Route {...props} /> : <Redirect to={paths.login} />
}
const GuestRoute: React.FC<RouteProps> = ({ ...props }) => {
  const { isLoggedIn } = useAppSelector(({ user }) => user)

  return !isLoggedIn ? <Route {...props} /> : <Redirect to='/' />
}

const Routes: React.VFC = () => {
  const { isLoggedIn } = useAppSelector(({ user }) => user)
  const redirectTo = isLoggedIn ? paths.home : paths.login

  useEffect(() => {
    setTimeout(() => window.scroll({ top: 0, behavior: 'smooth' }))
  }, [location])

  return (
    <Switch>
      <GuestRoute path={paths.login} exact component={Login} />
      <ProtectedRoute path={paths.home} exact component={Home} />
      <ProtectedRoute path={paths.new} exact component={New} />
      <ProtectedRoute path={paths.plants} exact component={Plants} />
      <ProtectedRoute path={paths.scenarios} exact component={Scenarios} />
      <ProtectedRoute path={paths.results} exact component={Results} />
      <ProtectedRoute path={paths.storageSystems} exact component={StorageSystems} />
      <ProtectedRoute path={paths.resultDetail} exact component={ResultDetail} />
      <ProtectedRoute path={paths.resultDetail} exact component={ResultDetail} />
      <ProtectedRoute path={paths.resultComparison} exact component={ResultComparison} />
      {/* <ProtectedRoute path={paths.users} exact component={Users} /> */}

      <Redirect to={redirectTo} />
    </Switch>
  )
}

export default Routes
